export const isTopLevel = window.top === window.self

export const USER_TOKEN_KEY = 'shopapp.admintoken';